import { toFixedAccuracy } from 'src/app/shared/extensions/number.extensions';
import { DataType, IExtendedControl } from '../models/IExtendedControl';
import { PropertiesComponent } from '../properties.component';

export function isNumeric(dataType: DataType) {
    return dataType === DataType.Integer || dataType === DataType.Long || dataType === DataType.Float;
}

export function setFormValue(control: IExtendedControl, formValues: { [key: string]: string | number }, key: string, propertiesComponent: PropertiesComponent): void {
    if (typeof formValues[key] === 'number') {
        formValues[key] = JSON.stringify(formValues[key]);
    }

    const isNumber = isNumeric(control.dataType);

    if (isNumber && control.hasGradientOrOffset) {
        formValues[key] = toFixedAccuracy((formValues[key] as unknown as number) * control.gradient + control.offset, control.displayFormat);
    } else if (isNumber) {
        formValues[key] = toFixedAccuracy(formValues[key], control.displayFormat);
    }

    // Check if there are controls where user have made a change and restore the value which the user has entered
    const dirtyControl = propertiesComponent.dirtyControls?.find((entity) => (entity as IExtendedControl).name === key);
    if (!!dirtyControl) {
        formValues[key] = dirtyControl.value;
        control.markAsDirty();
    }
}
